module.exports = __webpack_public_path__ + "6fdc78f4f627783f61945b214a779e87.MP3";